import React from 'react';
import { styled } from '@mui/material/styles';
import Charts from '../../containers/Chart/chart'
import { Carousel } from 'react-responsive-carousel';
import "../../styles/carouselCustom.css";

const PREFIX = 'ChartSlider';

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
  legend: `${PREFIX}-legend`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.container}`]: {
    marginLeft: '50px',
    marginRight: '50px',
    marginBottom: '50px',
    paddingBottom: '20px',
    paddingTop: '20px',
    maxHeight: '100%',
  },

  [`& .${classes.title}`]: {
    textAlign: "center"
  },

  [`& .${classes.legend}`]: {
    marginLeft: '10px'
  }
}));

function ChartSlider(props) {

  const {
    currentSlide,
    multipleChartData,
    height,
    width,
    barWidth,
    updateCurrentSlide
  } = props;
    

  return (
    <Root>
        <Carousel
            autoPlay = {true}
            interval = {3000000}
            infiniteLoop = {true}
            showThumbs = {false}
            selectedItem = {currentSlide}
            showStatus = {true}
            showIndicators = {true}
            showArrows = {true}
            onChange = {updateCurrentSlide}
            swipeScrollTolerance = {20}
        >
            {multipleChartData.map((chartData) => <div key={chartData.id} id={chartData.divID}>
                <Charts 
                    windowHeight={height}
                    windowWidth={width}
                    chartData={chartData}
                    barWidth={barWidth}
                />
            </div>)}
        </Carousel>
    </Root>
  );
}

export default ChartSlider;

